import { HttpApi } from './HttpApi';
import endpoints from '../endpoints';

export const ApiDiscord = {
  verifyDiscord: (jwt: string) => (
    HttpApi.get(`${endpoints.discordVerify}?jwt=${jwt}`)
  )
};
